/**
 * Sanitize error messages before showing to users.
 * Replaces messages that contain sensitive/internal keywords with a generic message.
 */

const GENERIC_MESSAGE = 'Something went wrong. Please try again.';

const SENSITIVE_PATTERNS = [
  /\bmobibox\b/i,
  /\bcolumn\b/i,
  /\bfield\s+list\b/i,
  /\bunknown\s+column\b/i,
  /\bsql\b/i,
  /\binsert\s+into\b/i,
  /\bupdate\s+.*\s+set\b/i,
  /\bdelete\s+from\b/i,
  /\bselect\s+.*\s+from\b/i,
  /\bwhere\s+id\s*=\s*\?\b/i,
  /\blambda\b/i,
  /\binternal\s+server\s+error\b/i,
  /\bstack\s*trace\b/i,
  /\bat\s+.*\.(js|ts)\s*:/i,
  /\bmysql\b/i,
  /\bdatabase\b/i,
  /\berror\s+code\s*\d+/i,
  /\bECONNREFUSED\b/,
  /\bETIMEDOUT\b/,
  /\benotfound\b/i,
];

/**
 * Returns a safe message for the user. If the message contains any sensitive
 * pattern, returns GENERIC_MESSAGE. Otherwise returns the original (trimmed).
 * @param {string} [message] - Raw error message from API or exception
 * @returns {string}
 */
export function sanitizeErrorMessage(message) {
  if (message == null) return GENERIC_MESSAGE;
  const str = String(message).trim();
  if (!str) return GENERIC_MESSAGE;
  const isSensitive = SENSITIVE_PATTERNS.some((re) => re.test(str));
  return isSensitive ? GENERIC_MESSAGE : str;
}

export default sanitizeErrorMessage;
